import {
  IPipelineBreakdownDimensionData,
  IPipelineDashboardBreakdownsGetOne,
} from '@/bundles/Pipeline/types';

export default class PipelineDashboardBreakdownsModel implements IPipelineDashboardBreakdownsGetOne {
  property_type: IPipelineBreakdownDimensionData;
  source: IPipelineBreakdownDimensionData;
  transaction_category: IPipelineBreakdownDimensionData;

  constructor (payload: IPipelineDashboardBreakdownsGetOne) {
    this.property_type = payload.property_type;
    this.source = payload.source;
    this.transaction_category = payload.transaction_category;
  }
}
